import { useSelector } from 'react-redux';

import { MOBILE_APP_TAKE_OVER } from '../constants';
import { draftsSlice } from '../slices/drafts';
import { webApp } from '../types/webapp';

import { useDraft } from './useDraft';

export type MobileAppTakeoverDraft = {
  draftKey?: string;
};
export const useMobileTakeoverDraft = <T extends webApp.MobileAppTakeOverDraft>({
  draftKey = MOBILE_APP_TAKE_OVER,
}: MobileAppTakeoverDraft) => {
  const draftHelpers = useDraft<webApp.MobileAppTakeOverDraft>(draftKey);
  const draft = useSelector(
    draftsSlice.selectors.getDraftByKey(draftKey),
  ) as T | undefined;

  const { addDraft, clearDraft } = draftHelpers;

  return {
    addDraft,
    clearDraft,
    draft,
  };
};
